import { shuffle } from "scripts/util/Helpers";
import AssetLoader from "../loaders/AssetLoader";
import Level from "../game/Level";
// import PresentParticles from "scripts/util/PresentParticles";


const TOTAL_LEVELS = 7; // 5;  // 0 indexed
const LEVEL_SEGMENT_TOTAL = 360 / 30;
const LEVEL_SEGMENT_SIZE = (Math.PI * 2) / LEVEL_SEGMENT_TOTAL;

class LevelManager {
  init(trackGroup) {
    this.trackGroup = trackGroup;
    this.pool = {};
    // this.masterList = ["one", "two", "three", "four", "five", "six"];
    // this.keys = shuffle([...this.masterList])
    this.regularLevels = ["one", "two", "three", "shortcut"];
    this.keysRegular = shuffle([...this.regularLevels]);

    this.levelCount = 0;
    this.isEnd = false;

    this.currentLevelIndex = -1;
    this.currentLevel = this.newLevel();

    this.currentLevelIndex = 0;
    this.nextLevel = this.newLevel();
  }

  setLevel(level) {
    this.level = level;
  }

  addCallback(callback) {
    this.callback = callback;
  }

  getNewKey() {
    if (this.level) {
      return this.level;
    }
    // return "fourcave"; 
    // if (this.levelCount === 0) return "two"; // TEST LEVEL ON PAUSE
    // if (this.levelCount === 0) return "fourcave";
    // if (this.levelCount === 1) return "fivecave";

    if (this.levelCount === 0) return "start";
    if (this.levelCount === 1) return "one";
    if (this.levelCount === 2) return "shortcut";
    if (this.levelCount === 3) return "fourcave";
    if (this.levelCount === 4) return "fivecave";
    if (this.levelCount === 5) return "two";
    if (this.levelCount === 6) return "three";
    if (this.levelCount === TOTAL_LEVELS) return "end";
    return "test";
    // if(this.levelCount%2===0) return "blank";
    // else return "test";

    // let key;
    // if (this.levelCount === TOTAL_LEVELS) {
    //   key = "end";
    // } else if (this.levelCount === 0) {
    //   key = "start";
    // } else {
    //   if (this.levelCount === 2) {
    //     key = "shortcut";
    //   } else {
    //     key = this.keys.pop()
    //     key = this.masterList.pop();
    //   }
    // }

    // return key;
  }

  newLevel() {
    const key = this.getNewKey();
    const nextLevelIndex = (this.currentLevelIndex + 1) % LEVEL_SEGMENT_TOTAL;

    const data = AssetLoader.getData(key);
    const nextLevel = new Level(key + this.levelCount, key, data);
    nextLevel.view.parent = this.trackGroup;
    nextLevel.view.rotation.x = -LEVEL_SEGMENT_SIZE * nextLevelIndex;
    nextLevel.reset();

    this.levelCount++;

    return nextLevel;
  }

  placeNewLevel() {
    console.log("place new level");
    if (this.currentLevel.type === "end") {
      this.callback("Success");
    } else {
      const oldLevel = this.currentLevel;
      oldLevel.destroy();

      this.currentLevel = this.nextLevel;
      if (this.currentLevel.type !== "end") {
        this.nextLevel = this.newLevel();
      }
    }
  }

  removeLevel(level) {}

  update(nextRotation) {
    let levelIndex = Math.floor(nextRotation / LEVEL_SEGMENT_SIZE);
    if (this.currentLevelIndex < levelIndex) {
      this.currentLevelIndex = levelIndex;
      this.placeNewLevel();
    }
  }
}

export default new LevelManager();
